import axios from 'axios';
import { isChrome, isFirefox, isSafari, isOpera, isEdge, isIE } from 'react-device-detect';

export const baseURL = 'https://enermerco.datamais.com.br/api/';
// export const baseURL = 'http://192.168.0.190:8009/api/';
// export const baseURL = 'https://enermerco.datamais.inf.br/api/v1/';

const api = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use((config) => {
  let browserName = '';

  if (isChrome) {
    browserName = 'Google Chrome';
  } else if (isFirefox) {
    browserName = 'Mozilla Firefox';
  } else if (isSafari) {
    browserName = 'Apple Safari';
  } else if (isOpera) {
    browserName = 'Opera';
  } else if (isEdge) {
    browserName = 'Microsoft Edge';
  } else if (isIE) {
    browserName = 'Internet Explorer';
  } else {
    browserName = 'Outro';
  }
  const data = config.data || {};

  if (data instanceof FormData) {
    config.headers['Content-Type'] = 'multipart/form-data';
  }

  config.headers['User'] = browserName;
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('TOKEN')}`;

  return config;
});

export default api;
